import { useEffect, useState } from 'react'

import NoSitesFound from './no-sites-found'
import SearchIcon from '../../../assets/images/icons/search-lg.svg?react'
import SitesIcon from '../../../assets/images/icons/sites-icon.svg?react'
import type { BreakdownInfo } from '../../../store/types/company'
import type { SortDirection } from '../../../store/types/filter'
import SitesTable from '../table'

function Companies({ data }: { data?: BreakdownInfo[] }) {
  const [articles, setArticles] = useState<BreakdownInfo[]>()
  const [searchValue, setSearchValue] = useState('')
  const [sortColumn, setSortColumn] = useState<keyof BreakdownInfo>('url')
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc')

  const filterArticles = (searchValue: string) => {
    if (searchValue === '') {
      return data
    }
    return data?.filter((i) => i.url.includes(searchValue.toLowerCase()))
  }

  useEffect(() => {
    setArticles(data)
  }, [data])

  function sortData(column: keyof BreakdownInfo) {
    let direction: SortDirection = 'asc'
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc'
    }
    const sortedData = articles
      ? [...articles].sort((a, b) => {
          if (
            column === 'c' ||
            column === 'prisync_index' ||
            column === 'match_percentage'
          ) {
            if (parseInt(a[column]) > parseInt(b[column])) {
              return direction === 'asc' ? 1 : -1
            } else if (parseInt(a[column]) < parseInt(b[column])) {
              return direction === 'asc' ? -1 : 1
            } else {
              return 0
            }
          } else {
            if (a[column] > b[column]) {
              return direction === 'asc' ? 1 : -1
            } else if (a[column] < b[column]) {
              return direction === 'asc' ? -1 : 1
            } else {
              return 0
            }
          }
        })
      : articles
    setArticles(sortedData)
    setSortColumn(column)
    setSortDirection(direction)
  }

  useEffect(() => {
    const filteredArticles = filterArticles(searchValue)
    setArticles(filteredArticles)
  }, [searchValue])

  return (
    <div className="flex flex-col border border-solid border-gray-200 rounded-lg shadow mb-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-solid border-gray-200 container mx-auto p-6">
        <div className="flex flex-col">
          {articles?.length !== 0 ? (
            <>
              {searchValue === '' ? (
                <div>
                  <div className="flex flex-row items-center gap-2 pb-1">
                    <SitesIcon />
                    <p className="font-medium text-lg text-gray-900">
                      {articles?.length} Sites
                    </p>
                  </div>
                  <div className="flex flex-row mt-2">
                    <p className="font-normal text-sm text-gray-500">
                      Your company is listed
                      <span>
                        {' '}
                        #
                        {articles?.map(
                          (articles, index) => articles.mine === 1 && index + 1,
                        )}
                        .
                      </span>{' '}
                      Keep track of the sites your products are listed.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="flex flex-row items-center gap-2">
                  <SitesIcon />
                  <p className="font-medium text-lg text-gray-900">
                    {articles?.length} Results found
                  </p>
                </div>
              )}
            </>
          ) : (
            <p>No results found</p>
          )}
        </div>
        <SearchBar
          callback={(searchValue: string) => setSearchValue(searchValue)}
        />
      </div>
      <div className="flex flex-col pt-6">
        {articles?.length === 0 ? (
          <NoSitesFound
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        ) : (
          <SitesTable
            data={articles}
            sortData={sortData}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
          />
        )}
      </div>
    </div>
  )
}

export default Companies

const SearchBar = ({ callback }: { callback: any }) => {
  const [innerValue, setInnerValue] = useState('')
  return (
    <div className="flex flex-row w-full md:w-1/5 pt-4 md:pt-0 ">
      <div className="flex flex-row w-full h-9 border border-solid rounded-lg items-center">
        <div className="px-2">
          <SearchIcon className="w-4 h-4" />
        </div>
        <input
          type="text"
          value={innerValue}
          onChange={(e) => {
            setInnerValue(e.target.value)
            callback(e.target.value)
          }}
          className="w-full text-sm focus:ring-0 !outline-none"
          placeholder="Search"
        ></input>
      </div>
    </div>
  )
}
